export default "__VITE_ASSET__CEPx787W__"